import { ReactElement } from "react";
import { Container, Typography, Box, Divider, Card } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

// components
import { BannerSection } from "./components/Banner_SystemDev";
import ImgDev1 from "@imgs/dev_1.png";
import ImgDev2 from "@imgs/dev_2.png";
import ImgDev3 from "@imgs/dev_3.png";
import ImgDev4 from "@imgs/dev_4.png";
import ImgDev5 from "@imgs/dev_5.png";
import ImgDev6 from "@imgs/dev_6.png";
import ImgDev7 from "@imgs/dev_7.png";
import ImgDev8 from "@imgs/dev_8.png";



const SvcMaintSupportPage = (): ReactElement => {

  return (
    <>
      <BannerSection />
      <Container sx={{ my: 1, p: 5, maxWidth: "1170px", }}>
        <Grid container spacing={2} sx={{ mx: 'auto', justifyContent: "center", maxWidth: '860px', minHeight: '500px' }}>
          <Grid sm={12} xs={12}>
            <Typography component="div" sx={{ fontSize: '32px', fontWeight: 800, color: '#505050', }}>システム開発の流れ</Typography>
          </Grid>
          <Grid sm={12} xs={12}>
            <Typography component="div" sx={{ fontSize: '28px', fontWeight: 400, color: '#3F51B5', }}>1. 要件定義</Typography>
            <Divider />
          </Grid>
          <Grid sm={6} xs={12}>
            <Box sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
              <Typography component="div" sx={{ fontSize: '14px', fontWeight: 400, color: '#303030', }}>
                システム開発の最初のステップであり、
                システムがカバーする範囲や、実現方法などを決定し、システムの大まかな仕様を「システム要件」として定義します。
                <br />
                <br />
                以降のステップはすべて、この「システム要件」を満たすために実行されます。ここでしっかりと要件を定義しておかないと、後に大きなスケジュールの遅れや、コストの増加など、問題が起きる場合があります。
                <br />
                <br />
                要件定義ではまず、ユーザーにヒアリングを行います。その結果を踏まえ、「システム要件」を定義した「要件定義書」を作成します。
                <br />
                <br />
                経営陣に対してはビジネス上の課題や今後の展望について、システム管理部門に対しては現状のシステム構成や使用しているツールなどについてヒアリングします。また、業務部門に対して、現状の業務内容や業務フロー、困りごとをヒアリングする場合もあります。              </Typography>
            </Box>
          </Grid>
          <Grid sm={6} xs={12} sx={{ display: { sm: 'block', xs: 'none' } }}>
            <Box
              component="img"
              src={ImgDev1}
              sx={{ textAlign: 'center', width: 350, }}
            />
          </Grid>
          <Grid sm={12} xs={12}>
            <Typography component="div" sx={{ fontSize: '28px', fontWeight: 400, color: '#3F51B5', }}>
              2. スケジュール設定
            </Typography>
            <Divider />
          </Grid>
          <Grid sm={6} xs={12}>
            <Box
              component="img"
              src={ImgDev2}
              sx={{ textAlign: 'center', width: 350, }}
            />
          </Grid>
          <Grid sm={6} xs={12} sx={{ display: { sm: 'block', xs: 'none' } }}>
            <Box sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
              <Typography component="div" sx={{ fontSize: '14px', fontWeight: 400, color: '#303030', }}>
                プロジェクトの進捗管理などを行う際、スケジュールと一定の間隔で立てられている標識として、マイルストンを設定します。
                <br />
                <br />

              </Typography>
            </Box>
          </Grid>
          <Grid sm={12} xs={12}>
            <Typography component="div" sx={{ fontSize: '28px', fontWeight: 400, color: '#3F51B5', }}>
              3. 外部設計
            </Typography>
            <Divider />
          </Grid>
          <Grid sm={6} xs={12}>
            <Box sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
              <Typography component="div" sx={{ fontSize: '14px', fontWeight: 400, color: '#303030', }}>
                システムの基本的な構成を設計するステップで、「基本設計」とも呼ばれます。
                <br />
                <br />
                サービスを提供するサーバーや、利用者が使用するクライアントなど、システムのハードウェアを検討します。
                また、システムで使用するネットワークや、ミドルウェアと呼ばれる中間ソフトウェア、プログラミングに使用するプログラミング言語など、ソフトウェアについても検討します。
                <br />
                <br />
                システムの画面構成など、人の目に触れる部分の設計も行います。
              </Typography>
            </Box>
          </Grid>
          <Grid sm={6} xs={12} sx={{ display: { sm: 'block', xs: 'none' } }}>
            <Box
              component="img"
              src={ImgDev3}
              sx={{ textAlign: 'center', width: 350, }}
            />
          </Grid>
          <Grid sm={12} xs={12}>
            <Typography component="div" sx={{ fontSize: '28px', fontWeight: 400, color: '#3F51B5', }}>
              4. 内部設計
            </Typography>
            <Divider />
          </Grid>
          <Grid sm={6} xs={12}>
            <Box
              component="img"
              src={ImgDev4}
              sx={{ textAlign: 'center', width: 350, }}
            />
          </Grid>
          <Grid sm={6} xs={12} sx={{ display: { sm: 'block', xs: 'none' } }}>
            <Box sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
              <Typography component="div" sx={{ fontSize: '14px', fontWeight: 400, color: '#303030', }}>
                外部設計よりもさらに詳細な設計を行うステップで、「詳細設計」とも呼ばれます。
                <br />
                <br />
                ユーザーが操作する画面の裏で、内部的に実行される処理について、処理のロジックや内部データの構造などを、詳細に定義します。
                <br />
                <br />
                この内部設計をもとにしてプログラミングが行われます。
              </Typography>
            </Box>
          </Grid>
          <Grid sm={12} xs={12}>
            <Typography component="div" sx={{ fontSize: '28px', fontWeight: 400, color: '#3F51B5', }}>
              5. コーディング
            </Typography>
            <Divider />
          </Grid>
          <Grid sm={6} xs={12}>
            <Box sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
              <Typography component="div" sx={{ fontSize: '14px', fontWeight: 400, color: '#303030', }}>
                内部設計を元に、実際にプログラムを作っていくステップです。
                <br />
                <br />
                システムの規模にもよりますが、通常は複数のプログラマーが同時にプログラミングを行います。
                <br />
                そのため、矛盾が生じないように「バージョン管理システム」を使って、作業中のデータを管理します。
              </Typography>
            </Box>
          </Grid>
          <Grid sm={6} xs={12} sx={{ display: { sm: 'block', xs: 'none' } }}>
            <Box
              component="img"
              src={ImgDev5}
              sx={{ textAlign: 'center', width: 350, }}
            />
          </Grid>
          <Grid sm={12} xs={12}>
            <Typography component="div" sx={{ fontSize: '28px', fontWeight: 400, color: '#3F51B5', }}>
              6. テスト
            </Typography>
            <Divider />
          </Grid>
          <Grid sm={6} xs={12}>
            <Box
              component="img"
              src={ImgDev6}
              sx={{ textAlign: 'center', width: 350, }}
            />
          </Grid>
          <Grid sm={6} xs={12} sx={{ display: { sm: 'block', xs: 'none' } }}>
            <Box sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
              <Typography component="div" sx={{ fontSize: '14px', fontWeight: 400, color: '#303030', }}>
                設計通りにプログラムが作成されているか、確認するステップです。
                <br />
                <br />
                どんなに注意して作業していても、人間が行う作業である以上、ミスは発生します。
                <br />
                また、設計時には予測できなかった不具合や、複数のプログラム部品を組み合わせてみて、初めて発生する不具合などもあります。
                <br />
                <br />
                システムをリリースする前に、ミスや不具合を解消して、品質を高めるのが「テスト」ステップの目的です。
                <br />
                <br />
                また次の表のように、テストにはいくつか種類があります。「対応するステップ」列で定義したことが実現できているかどうかを、「テストの種類」で記述しているテストで確認を行います。
              </Typography>
            </Box>
          </Grid>
          <Grid sm={12} xs={12}>
            <Typography component="div" sx={{ fontSize: '28px', fontWeight: 400, color: '#3F51B5', }}>
              7. 引き渡し（リリース）
            </Typography>
            <Divider />
          </Grid>
          <Grid sm={6} xs={12}>
            <Box sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
              <Typography component="div" sx={{ fontSize: '14px', fontWeight: 400, color: '#303030', }}>
                開発とテストが完了して、一定の品質が確保できたら、システムをユーザーに引き渡します（リリース）。
                <br />
                <br />
                単に引き渡すだけではなく、実際にシステムを使用するユーザーが困らないよう、操作方法についてのトレーニングを行ったり、ドキュメントを整備したりします。
                <br />
                <br />
                また、引き渡された側は、システムが要求した仕様を満たしていることを確認する（これを「検収」といいます）必要があります。
              </Typography>
            </Box>
          </Grid>
          <Grid sm={6} xs={12} sx={{ display: { sm: 'block', xs: 'none' } }}>
            <Box
              component="img"
              src={ImgDev7}
              sx={{ textAlign: 'center', width: 350, }}
            />
          </Grid>
          <Grid sm={12} xs={12}>
            <Typography component="div" sx={{ fontSize: '28px', fontWeight: 400, color: '#3F51B5', }}>
              8. 運用・サポート
            </Typography>
            <Divider />
          </Grid>
          <Grid sm={6} xs={12}>
            <Box
              component="img"
              src={ImgDev8}
              sx={{ textAlign: 'center', width: 350, }}
            />
          </Grid>
          <Grid sm={6} xs={12} sx={{ display: { sm: 'block', xs: 'none' } }}>
            <Box sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
              <Typography component="div" sx={{ fontSize: '14px', fontWeight: 400, color: '#303030', }}>
                リリースしたらシステム開発は終了、というわけではなく、運用開始後もサポートを継続します。
                <br />
                <br />
                実際のデータを使用して運用すると、開発段階では予測できなかった不具合が発生することがあります。また、ユーザーが想定外の操作を行ったためにエラーが発生する場合もあります。
                <br />
                <br />
                サーバーやクライアントPCなどのハードウェアが故障することや、オペレーティングシステムへの更新プログラム適用が必要になる場合もあります。
                <br />
                <br />
                このため「運用チーム」を用意しておき、システムのリリース後に発生した問題に対処します。その他「運用チーム」は、安定してシステムが稼働するように監視したり、問題が起きていないか、定期的にヒアリングを行ったりします。
                また、ユーザーから挙がってきた追加要望をまとめておき、後日、追加開発を行う場合もあります。
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container >
    </>
  );
};

export default SvcMaintSupportPage;
